var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessaccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9176_949",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9176_949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 20C4.45 20 3.97917 19.8042 3.5875 19.4125C3.19583 19.0208 3 18.55 3 18V17.2C3 16.6333 3.14583 16.1125 3.4375 15.6375C3.72917 15.1625 4.11667 14.8 4.6 14.55C5.63333 14.0333 6.68333 13.6458 7.75 13.3875C8.81667 13.1292 9.9 13 11 13C11.2333 13 11.4667 13.0042 11.7 13.0125C11.9333 13.0208 12.1667 13.0417 12.4 13.075C12.5833 13.0917 12.7292 13.1625 12.8375 13.2875C12.9458 13.4125 13 13.5667 13 13.75C13.0333 14.5333 13.225 15.2708 13.575 15.9625C13.925 16.6542 14.3917 17.2417 14.975 17.725C15.0917 17.8083 15.1833 17.9125 15.25 18.0375C15.3167 18.1625 15.35 18.3 15.35 18.45V19C15.35 19.2833 15.2542 19.5208 15.0625 19.7125C14.8708 19.9042 14.6333 20 14.35 20H5ZM11 12C9.9 12 8.95833 11.6083 8.175 10.825C7.39167 10.0417 7 9.1 7 8C7 6.9 7.39167 5.95833 8.175 5.175C8.95833 4.39167 9.9 4 11 4C12.1 4 13.0417 4.39167 13.825 5.175C14.6083 5.95833 15 6.9 15 8C15 9.1 14.6083 10.0417 13.825 10.825C13.0417 11.6083 12.1 12 11 12ZM18.5 14C18.7833 14 19.0208 13.9042 19.2125 13.7125C19.4042 13.5208 19.5 13.2833 19.5 13C19.5 12.7167 19.4042 12.4792 19.2125 12.2875C19.0208 12.0958 18.7833 12 18.5 12C18.2167 12 17.9792 12.0958 17.7875 12.2875C17.5958 12.4792 17.5 12.7167 17.5 13C17.5 13.2833 17.5958 13.5208 17.7875 13.7125C17.9792 13.9042 18.2167 14 18.5 14ZM18.65 22.65L17.65 21.65C17.6167 21.6167 17.5667 21.5 17.5 21.3V16.85C16.7667 16.6333 16.1667 16.2208 15.7 15.6125C15.2333 15.0042 15 14.3 15 13.5C15 12.5333 15.3417 11.7083 16.025 11.025C16.7083 10.3417 17.5333 10 18.5 10C19.4667 10 20.2917 10.3417 20.975 11.025C21.6583 11.7083 22 12.5333 22 13.5C22 14.25 21.7875 14.9167 21.3625 15.5C20.9375 16.0833 20.4 16.5 19.75 16.75L20.65 17.65C20.75 17.75 20.8 17.8667 20.8 18C20.8 18.1333 20.75 18.25 20.65 18.35L19.85 19.15C19.75 19.25 19.7 19.3667 19.7 19.5C19.7 19.6333 19.75 19.75 19.85 19.85L20.65 20.65C20.75 20.75 20.8 20.8667 20.8 21C20.8 21.1333 20.75 21.25 20.65 21.35L19.35 22.65C19.25 22.75 19.1333 22.8 19 22.8C18.8667 22.8 18.75 22.75 18.65 22.65Z",
    fill: "#242424"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessaccount);
export default __webpack_public_path__ + "static/media/access account.3754aa39b69a54e762a3ddc9f49581d2.svg";
export { ForwardRef as ReactComponent };